<template>
	<Col class="analytics-card-container width-100">
		<slot />
	</Col>
</template>
<script>
export default { name: 'AnalyticsCard' };
</script>
<style scoped lang="scss">
.analytics-card-container {
	border-radius: 15px;
	background: var(--white);
	border: 1px solid #e2e7f0;
	transition: var(--transition-time);
	&:hover {
		box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);
	}
}
</style>
